module.exports = __webpack_public_path__ + "img/logo-app.c8137679.svg";